














import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const loginerModule = namespace('loginer')
@Component
export default class NotifyDetails extends Vue {
	@loginerModule.Mutation('SET_LOGINER') private setLoginer!: any
	private notifyDetailsData: object = {}
	private created () {
		this.refreshNotifyDetails()
	}
	private refreshNotifyDetails () {
		const id = (this as any).$route.query.id
		return (this as any).$fxHttp.requestGet({
			url: '/announcement/read/' + id,
			fullData: true
		}).then((res: any) => {
			this.notifyDetailsData = res.data
			this.setLoginer({
				loginerNotifyNumber: res.otherdata.unReadAnnoCount || ''
			})
			// this.shortcutsData = res.otherdata
		})
	}
}
